import { Pipe, PipeTransform } from '@angular/core';

import { pedidoSetoresGep, isPedidoSetorGepExpedicao, isPedidoSetorGepExpedicaoASeparar, isPedidoSetorGepExpedicaoEmSeparacao, setorGepExpedicaoASeparar, setorGepExpedicaoEmSeparacao } from '../pedido-setor-gep';

@Pipe({
    name: 'pedidoSetorGep'
})
export class PedidoSetorGepPipe implements PipeTransform {
    transform(value: number, considerarEtapExpedicao: boolean = false, dataInicioExpedicao: Date = null, dataTerminoExpedicao: Date =null): string {
        if (!value) {
            return '';
        }

        // Expedição
        if (considerarEtapExpedicao && isPedidoSetorGepExpedicao(value)) {
            if (isPedidoSetorGepExpedicaoASeparar(value, dataInicioExpedicao)) { // A Separar
                return setorGepExpedicaoASeparar.nome;
            } else if (isPedidoSetorGepExpedicaoEmSeparacao(value, dataInicioExpedicao, dataTerminoExpedicao)) { // Em Separação
                return setorGepExpedicaoEmSeparacao.nome;
            }
        }

        const index = pedidoSetoresGep.findIndex(setorGep => setorGep.id === value);
        if (index > -1) {
            return pedidoSetoresGep[index].nome;
        }
        return '';
    }
}
